import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const slideIn = keyframes`
  from {
    transform: translateY(50%);
  }

  to {
    transform: translateY(0);
  }
`;

export const glow = keyframes`
  0% {
    box-shadow: -2px -3px 10px 0 var(--gradient-one-color), 4px 4px 12px 0 var(--gradient-two-color);
    background-size: 200% 215%;
  }
  25% {
    box-shadow: -3px 4px 12px 0 var(--gradient-one-color), 4px -2px 12px 0 var(--gradient-two-color);
    background-size: 190% 200%;
  }
  50% {
    box-shadow: 4px 3px 12px 0 var(--gradient-one-color), -3px -4px 10px 0 var(--gradient-two-color);
    background-size: 100% 165%;
  }
  75% {
    box-shadow: 4px -4px 12px 0 var(--gradient-one-color), -3px 4px 12px 0 var(--gradient-two-color);
    background-size: 170% 350%;
  }
  100% {
    box-shadow: -2px -3px 10px 0 var(--gradient-one-color), 4px 4px 12px 0 var(--gradient-two-color);
    background-size: 200% 215%;
  }
`;

export const AnimatedFadeIn = styled.div.attrs<{ $delaySecond: number }>(
  (props) => ({
    $delaySecond: props.$delaySecond ?? 0,
  }),
)`
  opacity: 0;
  animation: ${fadeIn} 0.6s ease-in-out forwards;
  animation-delay: ${(props) => props.$delaySecond}s;
`;
